/* eslint-disable no-underscore-dangle */
import { Component, Input, SimpleChanges, OnChanges } from '@angular/core';

import { HisAuthService, DynamicObjects, GUIComponent, GUIComponentField } from 'hisng';

import { DynamicFieldValueUtils } from 'app/fs/res/common/service/dynamic-content/dynamic-field-value.utils';
import { Patent } from 'app/fs/res/patent/model/patent/patent';
import { DynamicContentUtils } from 'app/fs/res/common/service/dynamic-content/dynamic-content-utils';

@Component( {
    selector: 'res-patent-view-dynamicfields',
    templateUrl: './patent-view-dynamicfields.component.html',
} )
export class PatentViewDynamicFieldsComponent implements OnChanges {
    @Input() patent: Patent = new Patent();
    @Input() dynamicContentTabName: string;

    public keyTableFieldIdValueMap: Map<string, string> = new Map<string, string>();;
    public priorityPatentDynamicChildren: GUIComponent[];
    public dynamicObjects: DynamicObjects[];

    constructor( public auth: HisAuthService,
        private dynamicContentUtils: DynamicContentUtils,
        public dynamicFieldValueUtils: DynamicFieldValueUtils ) {
    }

    ngOnChanges( changes: SimpleChanges ) {
        if ( changes ) {
            if ( this.patent && this.patent.priorityPatent && this.patent.priorityPatent._dynamicComponent ) {
                this.dynamicObjects = this.patent.priorityPatent._dynamicComponent.dynamicObjects;

                // find and map keytable values to this.keyTableFieldIdValueMap
                this.dynamicFieldValueUtils.setDynamicFieldKeyTableValues(
                    this.dynamicObjects, this.keyTableFieldIdValueMap );

                // set priority patent children
                this.priorityPatentDynamicChildren = this.getPriorityPatentDynamicChildren();
            }
        }
    }

    public getPriorityPatentDynamicChildren(): GUIComponent[] {
        let priorityPatentChildren: GUIComponent[] = [];
        // filter fields that have no value set
        this.patent.priorityPatent._dynamicComponent.guiComponent.children.sort(
            ( f1, f2 ) => f1.sortorder - f2.sortorder ).forEach(
            ( tabChild: GUIComponent ) => {
                tabChild.children.forEach( ( fieldSetChild: GUIComponent ) => {
                    fieldSetChild.fields = fieldSetChild.fields.sort(
                        ( f1, f2 ) => f1.sortorder - f2.sortorder ).filter(
                        ( fieldChild: GUIComponentField ) => {
                            return this.dynamicContentUtils.getDynamicObjectAttribute(
                                this.dynamicObjects, fieldChild.objectUID, fieldChild.attributeName, 'value' ) !== null;
                        } );
                } );
            } );
        // filter tab relevant entries and remove children that have no fields
        this.patent.priorityPatent._dynamicComponent.guiComponent.children.filter(
            ( tabChild: GUIComponent ) => tabChild.name === this.dynamicContentTabName ).forEach(
            ( tabChildren: GUIComponent ) => {
                priorityPatentChildren = tabChildren.children.filter( ( fieldSetChild: GUIComponent ) =>
                    fieldSetChild.fields.length !== 0 );
            } );
        return priorityPatentChildren;
    }

}
